/**
 * Product feature toggles — values come from VITE_ENABLE_* / VITE_OPEN_CONNECTOR in .env.{dev|stg|prod|test}.
 */
const normalizeFlag = (value?: string) => value?.trim().toLowerCase();

const isEnabled = (value?: string) => normalizeFlag(value) === 'true';

export const isGroupChatEnabled = isEnabled(import.meta.env.VITE_ENABLE_GROUP_CHAT);
export const isIncognitoChatEnabled = isEnabled(import.meta.env.VITE_ENABLE_INCOGNITO_CHAT);
export const isVoiceCallEnabled = isEnabled(import.meta.env.VITE_ENABLE_VOICE_CALL);
export const isOnboardingEnabled = isEnabled(import.meta.env.VITE_ENABLE_ONBOARDING);
export const isOpenConnectorEnabled = isEnabled(import.meta.env.VITE_OPEN_CONNECTOR);
export const isDashboardEnabled = isEnabled(import.meta.env.VITE_ENABLE_DASHBOARD);

export const FEATURE_FLAGS = {
  groupChat: isGroupChatEnabled,
  incognitoChat: isIncognitoChatEnabled,
  voiceCall: isVoiceCallEnabled,
  onboarding: isOnboardingEnabled,
  openConnector: isOpenConnectorEnabled,
  dashboard: isDashboardEnabled,
} as const;
